import { useState } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function NewPatientModal({ onClose, onCreate }) {
  const [form, setForm] = useState({ name: "", birthDate: "", phone: "", notes: "", crmLink: "", socialNetwork: "" });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { setError("Введите ФИО"); return; }
    setSaving(true);
    setError("");
    try {
      await onCreate(form);
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 z-[200] flex items-center justify-center"
      onMouseDown={e => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-2xl shadow-2xl w-[420px] max-w-[95vw] overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <span className="text-base font-bold text-slate-900">Новый пациент</span>
          <Button variant="ghost" size="icon" onClick={onClose} className="h-7 w-7">
            <X className="h-4 w-4" />
          </Button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="px-5 py-4 flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">ФИО *</Label>
              <Input placeholder="Иванов Иван Иванович" value={form.name}
                onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Дата рождения</Label>
              <Input type="date" value={form.birthDate}
                onChange={e => setForm(f => ({ ...f, birthDate: e.target.value }))} />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Телефон</Label>
              <Input placeholder="+7 900 000-00-00" value={form.phone}
                onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Соц. сеть</Label>
              <Input placeholder="ссылка или ник" value={form.socialNetwork}
                onChange={e => setForm(f => ({ ...f, socialNetwork: e.target.value }))} />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Ссылка CRM</Label>
              <Input placeholder="https://..." value={form.crmLink}
                onChange={e => setForm(f => ({ ...f, crmLink: e.target.value }))} />
            </div>
            {error && (
              <div className="text-xs text-red-600 bg-red-50 rounded-lg px-3 py-2">{error}</div>
            )}
          </div>
          <div className="flex justify-end gap-2 px-5 py-3 border-t border-slate-100">
            <Button type="button" variant="ghost" onClick={onClose}>Отмена</Button>
            <Button type="submit" disabled={saving}>
              {saving ? "Создание..." : "Создать пациента"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
